import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ShareService } from '../../services/share.service';
import { SpacesService } from '../../services/spaces.service';
import { ToastService } from '../../services/toast.service';
import { MatomoService } from '../../services/matomo.service';
import { Space } from '../../models/space.model';

@Component({
    selector: 'app-import-space',
    imports: [],
    templateUrl: './import-space.component.html',
    styleUrl: './import-space.component.scss'
})
export class ImportSpaceComponent implements OnInit {
  space: Space | null = null;
  error: string | null = null;
  importing = false;
  alreadyExists = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly shareService: ShareService,
    private readonly spacesService: SpacesService,
    private readonly toastService: ToastService,
    private readonly matomoService: MatomoService
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.queryParamMap.get('data');

    if (!data) {
      this.error = 'No space data found in the URL';
      return;
    }

    const space = this.shareService.deserializeSpace(data);

    if (!space) {
      this.error = 'Invalid or corrupted space data';
      return;
    }

    this.space = space;
    this.alreadyExists = this.spacesService.exists(space.name);
  }

  importSpace(): void {
    if (!this.space) return;

    this.importing = true;

    // If space with same name exists, create a new name
    let spaceName = this.space.name;
    let counter = 1;
    while (this.spacesService.exists(spaceName)) {
      spaceName = `${this.space.name} (${counter})`;
      counter++;
    }

    const spaceToImport: Space = {
      ...this.space,
      id: crypto.randomUUID(), // Always assign a fresh id on import
      name: spaceName,
      dateCreated: new Date(), // Use current date for import
    };

    const success = this.spacesService.add(spaceToImport);

    if (success) {
      this.matomoService.trackActionPageView(
        this.matomoService.CATEGORY.space,
        this.matomoService.ACTION.importSuccess,
        'import_space_page'
      );
      this.toastService.success(`Space "${spaceName}" imported successfully!`);
      this.router.navigate(['/spaces', spaceToImport.id]);
    } else {
      this.matomoService.trackActionPageView(
        this.matomoService.CATEGORY.space,
        this.matomoService.ACTION.importFailed,
        'import_space_page'
      );
      this.toastService.error('Failed to import space');
      this.importing = false;
    }
  }

  cancel(): void {
    this.router.navigate(['/spaces']);
  }
}
